import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../shared-module/helpers";
import { USER_ROLES } from "../app.config";
import { ReportsListComponent, ReportDetailComponent } from "./pages/";

const reportingRoutes: Routes = [
  {
    path: "reports",
    children: [
      {
        path: "list",
        component: ReportsListComponent
      },
      {
        path: ":reportType",
        component: ReportDetailComponent
      },
      {
        path: "**",
        component: ReportsListComponent
      },
    ],
    canActivate: [AuthGuard],
    data: {
      expectedRoles: [USER_ROLES.sales_manager, USER_ROLES.sys_admin]
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(reportingRoutes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule {}
